import { render, staticRenderFns } from "./GeneralTradingConditions.vue?vue&type=template&id=acd9ba5e&lang=pug&"
import script from "./GeneralTradingConditions.vue?vue&type=script&lang=js&"
export * from "./GeneralTradingConditions.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTradingConditions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports